/**
 * WidgetTypes.js
 *
 * Copyright (c) apploft. GmbH
 */
function typeMatchingString(_ref) {
  var format = _ref.format,
      allows = _ref.allows;

  if (Array.isArray(allows) && allows.length > 0) {
    return 'select';
  }

  if (!format) {
    return 'text';
  }

  if (format.some(function (_ref2) {
    var display = _ref2.display;
    return display === 'multiline-text';
  })) {
    return 'textarea';
  }

  if (format.some(function (_ref3) {
    var display = _ref3.display;
    return display === 'date-time';
  })) {
    return 'date';
  }

  return 'text';
}
/**
 * Returns the Form Input (`<input>`) type matching `type` and `format`.
 *
 * @param {{type: string, enum: [string], format: [{display:string}], allows: [string]}} props The widget properties to check for their type.
 */


function typeMatchingProps(_ref4) {
  var type = _ref4.type,
      format = _ref4.format,
      allows = _ref4.allows;

  switch (type) {
    case 'string':
    case 'number':
      return typeMatchingString({
        format: format,
        allows: allows
      });

    case 'boolean':
      return 'checkbox';

    default:
      throw new Error("unknown widget: ".concat(type));
  }
}

export { typeMatchingProps };